import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('search');
const type = createActionType('search');

export const SEARCH_PROJECTS = apiType('SearchProjects');
export const SELECT_PROJECT = type('SelectProject');
